import { VariableValue } from '@components/text-editors/addons/field-mapping';

import { request } from '../request';

export type JourneyActionReminder = {
  journeyAction?: string;
  shortId: string;
  emailNotify: boolean;
  smsNotify: boolean;
  emailData?: ReminderEmailData;
  smsData?: ReminderSmsData;
  days: string;
  hours: string;
  minutes: string;
  frequency?: string;
  amount?: string;
};

type ReminderEmailData = {
  content?: VariableValue;
  subject?: { value: string };
  recipients?: VariableValue[];
};

type ReminderSmsData = {
  message?: VariableValue;
  recipients?: VariableValue[];
};

export type ReminderSchedule = {
  id: number;
  travellerAction: string;
  reminderData: ReminderEmailData | ReminderSmsData;
  method: string;
  scheduledDate: string;
  status: 'not_started' | 'in_progress' | 'sent' | 'completed' | 'failed' | 'skipped';
  isAutomatic: boolean;
  dateSucceeded: string | null;
  dateFailed: string | null;
  statusMessage: string | null;
};

export const createManualReminder = async (reminder: any) => {
  const response = await request.post('v1/reminders/reminder-schedules/', reminder);
  return response.data;
};
